module.exports = __webpack_public_path__ + "assets/e50764639d1728047ff3f504a6518a91.png";